import React, { useState } from "react";
import Icon from "../../../assets/Icon";
import { Button, Card } from "antd";
import ActionModal from "./modals/ActionModal";

function ActionItem({
  actionableItemsObj,
  switchSystem,
  auth,
  interviewType,
  interviewId,
  getReport,
}) {
  const [actionModal, setActionModal] = useState();
  const [actionModalData, setActionModalData] = useState(null);
  let actionableItems = actionableItemsObj?.map((item) => ({
    reference: switchSystem ? item.reference : item.editedReference,
    actionsRequired: switchSystem
      ? item.actionsRequired
      : item.editedActionsRequired,
    interviewActionableId: item.interviewActionableId,
    edited: item.edited,
  }));
  return (
    <>
      {ActionModal && (
        <ActionModal
          actionModal={actionModal}
          setActionModal={setActionModal}
          actionModalData={actionModalData}
          auth={auth}
          interviewId={interviewId}
          interviewType={interviewType}
          getReport={getReport}
        />
      )}
      <div className="mt-10">
        <div className="flex gap-3 items-center font-semibold text-[1.275rem]">
          <p className="bg-[#206DC5] border inline-block p-3 rounded-xl">
            <Icon type="action-analysis-icon" width="18" height="19" />
          </p>
          <span>Actionable Items</span>
        </div>
        <div className="bg-[#D4E7FD] mt-4 border-2 flex flex-col  border-[#A9CFFB] p-4 rounded-lg">
          {actionableItems && actionableItems.length > 0 ? (
            actionableItems?.map((data, i) => (
              <>
                {switchSystem !== true && (
                  <p className="flex justify-end mb-1 items-end ">
                    {data?.edited && <p>Edited*</p>}
                    <Button
                      type="link"
                      onClick={() => {
                        setActionModal(true);
                        setActionModalData(data);
                      }}
                      className=""
                      size="small"
                    >
                      <Icon
                        type="skill-edit-modal-icon"
                        width="16"
                        height="16"
                      />
                    </Button>
                  </p>
                )}

                <Card key={i} className="border-2 mb-2">
                  <p className="avoid-break text-[1.225rem] leading-[1.7rem] text-[#101828] font-semibold">
                    <span className="text-[#12B76A] font-medium">
                      Reference:
                    </span>{" "}
                    {data?.reference || "N/A"}
                  </p>
                  <p className="avoid-break mt-2 text-[#475467] text-[.93rem] leading-[1.3rem]">
                    <span className="text-[#F04438] font-medium">
                      Action Required :{" "}
                    </span>
                    {data?.actionsRequired || "N/A"}
                  </p>
                </Card>
              </>
            ))
          ) : (
            <div className="text-slate-600 pl-2">No actionable items found.</div>
          )}
        </div>
      </div>
    </>
  );
}

export default ActionItem;
